import { Action } from 'redux';

import { ScheduleDisable, ScheduleDisableLinkedTask, ScheduleEdit, ScheduleEnable, ScheduleEnableLinkedTask,ScheduleRunNow } from '../../bootstrap/redux/actions/AppActionTypes';
import { IScheduleInfo } from '../types/IScheduleInfo';

export interface ScheduleMenuAction extends Action {
  items: IScheduleInfo[];
}

export function scheduleRunNow(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleRunNow,
    items
  };
}

export function scheduleEnable(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleEnable,
    items
  };
}

export function scheduleDisable(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleDisable,
    items
  };
}

export function scheduleEdit(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleEdit,
    items
  };
}

export function scheduleEnableLinkedTask(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleEnableLinkedTask,
    items
  };
}

export function scheduleDisableLinkedTask(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleDisableLinkedTask,
    items
  };
}
